import React from 'react';
import ChangePassword from '../components/changePassword/Component';

const Component = () => {
  return (
      <ChangePassword/>
  )
}

export default Component
